import { useObligations } from '@/hooks/queries/useFinanceDeadlines';

// The obligation kinds the action queue renders as cards (useActionQueueDescriptors). While one is
// waiting, the close hub must not claim there is nothing to file.
const QUEUED_KINDS = new Set(['RapidNotice', 'DailyAggregate', 'PreSessionAggregate']);

export function useHasQueuedObligation(): boolean {
  const obligations = useObligations().data?.obligations ?? [];
  return obligations.some((o) => o.isRapidReport || QUEUED_KINDS.has(o.obligationKind));
}
